export enum eventSlotStatus {
  open = 'Offen',
  reserved = 'Reserviert',
  booked = 'Gebucht',
  declined = 'Abgelehnt',
}
